module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-group row">\n    <label class="DescartesUILabel col-sm-5 col-form-label" for="nameResultLayer">Nom de la couche</label>\n    <div class="col-sm-7">\n       <input type="text"class="DescartesUIInput form-control" name="nameResultLayer" id="nameResultLayer" value="Couche résultat"/>\n    </div>\n</div>\n\n<div class="form-group row">\n    <label class="DescartesUILabel col-sm-5 col-form-label" for="colorResultLayer">Couleur</label>\n    <div class="col-sm-7">\n        <input type="color" class="DescartesUIInput form-control" name="colorFillResultLayer" id="colorFillResultLayer" value="' +
((__t = (colorFill)) == null ? '' : __t) +
'"/>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ResultLayerConfig.ejs
// module id = 389
// module chunks = 0